import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
const ForgotConfirmForm = forwardRef((props, ref) => {
    const { onSubmit } = props;
    const { register, handleSubmit, formState, control } = useForm({
        defaultValues: {
            code: '',
        },
    });
    useImperativeHandle(ref, () => ({
        handleSubmitForm: () => {
            handleSubmit((data) => onSubmit({
                code: data.code,
            }))();
        },
    }));
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.code, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, null, "\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F"),
            React.createElement(Controller, { name: 'code', control: control, render: ({ field }) => (React.createElement(InputMask, Object.assign({ mask: '999999', maskChar: '', value: field.value, onChange: field.onChange }, register(field.name, {
                    pattern: /^[0-9]{6}$/iu,
                    required: true,
                }), field), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F', variant: 'outlined', fullWidth: true, placeholder: '489327' }, inputProps))))) }))));
});
export default ForgotConfirmForm;
